import "./Structures.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import SubProductos from "./sections/SubProductos";
import Footer from "@/reusable_sections/Footer";
export default function StructuresPage() {
  return <div>
      <Header />
      <HeroBanner />
      <SubProductos />
      <Footer />
    </div>;
}